function formatNumber(value: number | string) {
  const prepareValue = typeof value === 'string' ? parseInt(value, 10) : value;
  return new Intl.NumberFormat().format(prepareValue).replace(',', '.');
}

export { formatNumber };
